<template>
  <div class="index">
   


    <div class="container">
      <!-- swiper 轮播 -->
      <div class="swiper">
        <!-- <img src="/imgs/banner.jpg" alt="" /> -->
        <div class="swiper-box">
          <swiper :options="swiperOption">
            <!-- 循环想 -->
            <swiper-slide v-for="(item, index) in this.swiperList" :key="index">
              <a href="javascript:;"><img :src="item.img" /></a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

   
   

      <!-- 音乐区块1 -->
      <div class="mc1">
        <h1>歌曲推荐</h1>
        <div class="con">
          <div class="l">
            <img src="/imgs/ct3.jpg" alt="" />
          </div>
          <div class="r">
            <!-- 循环项 *10 -->
            <div class="item" v-for="(item, index) in this.d1" :key="index"  @click="goDays(item.methods, item, index, item.id)">
              <div class="item-img">
                <div class="mat"></div>
                <img :src="item.img" alt="" />
                <i class="iconfont icon-xiazai"></i>
              </div>
              <span>收费下载：2元</span>
              <p>{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- banner -->
      <div class="banner">
        <img src="/imgs/ct1.jpg" alt="" />
      </div>

      <!-- 音乐区块2 -->
      <div class="mc2">
        <h1>新歌上架</h1>
        <div class="con">
          <!-- 循环项 *10 -->
          <div class="item" v-for="(item, index) in this.d2" :key="index"  @click="goDays(item.methods, item, index, item.id)">
            <!-- 图片 -->
            <div class="item-img">
              <img :src="item.img" alt="" />
              <div class="mat"></div>
              <i class="iconfont icon-xiazai"></i>
            </div>
            <p>{{item.title}}</p>
            <h4>收费下载：2元</h4>
          </div>
        </div>
      </div>

      <!-- banner -->
      <div class="banner">
        <img src="/imgs/ct2.jpg" alt="" />
      </div>

      <!-- 音乐区块3 -->
      <div class="mc3">
        <h1>热门排行</h1>

        <div class="con">
          <!-- 左侧 -->
          <div class="con-l">
            <img src="/imgs/ct4.jpg" alt="" />
          </div>
          <!-- 右侧 -->
          <div class="con-r">
            <div class="r-list">
              <!-- 循环项 *20 -->
              <div class="item" v-for="(item, index ) in this.d3" :key="index"  @click="goDays(item.methods, item, index, item.id)">
                <!-- id -->
                <span class="item-id">{{item.id}}</span>
                <!-- 图片 -->
                <div class="item-img">
                  <img :src="item.img" alt="" />
                </div>
                <!-- 标题 -->
                <div class="item-title">{{item.title}}</div>
                <!-- 收费 -->
                <div class="item-pay">收费下载：2元</div>

                <!-- 下载图标 -->
                <i class="iconfont icon-xiazai"></i>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <modal
        title="请选择支付方式"
        btnType="1"
        modalType="middle"
        :showModal="showModal"
        @submit="showModal = false"
        @cancel="showModal = false"
      >
        <template v-slot:body>
          <img src="/imgs/pay2.png" />
          <p>收费下载：2元/次</p>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Modal from "./../components/Modal.vue";
export default {
  components: {
    Modal,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      d1: [],
      d2: [],
      d3: [],
      d4: [],
      d5: [],
      d6: [],
      d7: [],
      my_data: [],
      showModal: false,
      user: JSON.parse(window.localStorage.getItem("user")),
      state: JSON.parse(window.localStorage.getItem("state")),
      // 轮播配置
      swiperOption: {
        autoplay: true,
        loop: true,
        loopedSlides: 5,
        effect: "fade",
        slidesPerView: "auto",
        centeredSlides: true,
        cubeEffect: {
          shadowOffset: 100,
          shadowScale: 0.6,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // 轮播数组
      swiperList: [
        {
          id: "1",
          img: "/imgs/banner.jpg",
        },
        {
          id: "2",
          img: "/imgs/banner2.jpg",
        },
      ],
    };
  },
  mounted() {
    document.title = "画娱网";
    this.init();
  },
  methods: {
    // 获取音乐数据
    init() {
      this.axios.get("/mock/index.json").then((res) => {
        this.d1 = res.data.slice(0, 10);
        this.d2 = res.data.slice(10, 20);
        this.d3 = res.data.slice(20, 40);

      });
    },
    // 真实支付逻辑
    alipay(data, index) {
      console.log(data);
      var payAmount = 2.00; //支付价格
      var orderName = "音乐下载支付"; //订单名称
      var id = index; //订单名称

      // 已登录
      if (this.state == 0) {
        window.open(
          "https://www.52huayu.cn/alipay/index.php?payAmount=" +
            payAmount +
            "&orderName=" +
            orderName +
            "&id=" +
            id
        );
      }
      // 未登录
      if (this.state !== 0) {
        alert("点击登录去购买~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    // 跳转 逻辑 封装
    goDays(methods, item, index, id) {
      this[methods](item, index, id);
    },
    // 跳转详情页
    goDetails(item, index, id) {
      // alert('123')
      console.log(item, index);
      this.$router.push({
        path: "/sound/:" + id,
        query: { id: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.index {


  // swiper 轮播 区块
  .swiper {
    width: 100%;
    height: 500px;
    margin: 30px 0;
  }
  .container {
    margin-top: 60px;

    // banner 区块
    .banner {
      width: 100%;
      height: 290px;
      border-radius: 10px;
      margin: 40px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }

    // 音乐区块1
    .mc1 {
      width: 100%;
      margin: 40px 0;
      h1 {
        width: 100%;
        margin: 10px 0;
        cursor: pointer;
      }
      .con {
        width: 100%;
        height: 402px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        .l {
          width: 25%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .r {
          flex: 1;
          margin-left: 25px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .item {
            width: 175px;
            height: 200px;
            position: relative;
            text-align: center;
            .item-img {
              width: 159px;
              height: 159px;
              border-radius: 10px;
              position: relative;
              cursor: pointer;
              &:hover {
                i {
                  opacity: 1;
                }
                .mat {
                  opacity: 1;
                }
              }
              img {
                width: 100%;
                height: 100%;
                border-radius: 20px;
              }
              i {
                position: absolute;
                font-size: 50px;
                left: 36%;
                top: 34%;
                opacity: 0;
                color: #fff;
                transition: all 0.3s;
              }
              .mat {
                width: 100%;
                height: 100%;
                position: absolute;
                background-color: rgba(0, 0, 0, 0.3);
                opacity: 0;
                transition: all 0.3s;
                 border-radius: 20px;
              }
            }
            span {
              position: absolute;
              top: 10px;
              right: 15%;
              width: 90px;
              height: 20px;
              background: rgba(0, 0, 0, 0.6);
              color: #fff;
              font-size: 12px;
              text-align: center;
              border-radius: 20px;
              line-height: 20px;
              cursor: pointer;
            }
            p {
              margin-top: 5px;
              width: 100%;
              font-size: 12px;
            }
          }
        }
      }
    }

    // 音乐区块2
    .mc2 {
      width: 100%;
      margin: 40px 0;
      h1 {
        width: 100%;
        margin: 10px 0;
        cursor: pointer;
      }
      .con {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        // 循环项
        .item {
          width: 220px;
          height: 255px;
          position: relative;
          cursor: pointer;
          margin: 10px 10px;
          &:hover {
            .item-img {
              .mat {
                opacity: 1;
              }
              i {
                opacity: 1;
              }
            }
          }
          // 图片
          .item-img {
            width: 100%;
            height: 200px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              border-radius: 15px;
            }
            .mat {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.3);
              opacity: 0;
              transition: all 0.3s;
              border-radius: 15px;
            }
            i {
              font-size: 60px;
              color: #fff;
              position: absolute;
              left: 34%;
              top: 33%;
              opacity: 0;
              transition: all 0.3s;
            }
          }

          p {
            font-size: 14px;
            width: 100%;
            margin-top: 10px;
          }
          h4 {
            width: 100%;
            margin-top: 15px;
            color: #888;
            font-size: 14px;
          }
        }
      }
    }

    // 音乐区块3
    .mc3 {
      width: 100%;
      margin: 40px 0;
      h1 {
        width: 100%;
        margin: 10px 0;
        cursor: pointer;
      }
      .con {
        width: 100%;
        height: 500px;
        background-color: #f2f2f2;
        display: flex;
        justify-content: space-between;
        .con-l {
          width: 40%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .con-r {
          width: 50%;
          height: 100%;
          margin-left: 20px;
          overflow: auto;
          .r-list {
            width: 100%;
            height: 100%;
            // 循环项
            .item {
              width: 100%;
              height: 72px;
              display: flex;
              align-items: center;
              padding: 0 10px;
              box-sizing: border-box;
              transition: all .3s;
              &:hover {
                background: rgb(175, 175, 175);
                color: #fff;
                i {
                  opacity: 1;
                }
              }
              // id
              .item-id {
                font-size: 14px;
                font-weight: bold;
                
              }
              // 图片
              .item-img {
                width: 60px;
                height: 60px;
                margin: 0 25px;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 5px;
                }
              }
              // 标题
              .item-title {
                font-size: 14px;
                margin: 0 15px ;
                width: 200px;
              }
              // 收费
              .item-pay {
                font-size: 14px;
                margin-right: 20px;
              }

              // 下载
              i {
                font-size: 24px;
                color: #fff;
                margin-left: 30px;
                cursor: pointer;
                transition: all .3s;
                opacity: 0;
                &:hover {
                  transform: scale(1.1);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
